export default "__VITE_ASSET__Behu2OiA__"